// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__l2oNM","loadingText":"loading_loadingText__c9yWu"};